import {
  ContentWide,
  ContentWrapper,
} from 'volto-essvoltocomponents/components/Layout';
import PageSection from '../../Layout/PageSection';
import PageHeaderSimple from '../../Molecules/PageHeaderSimple';
import PageHeaderBackground from '../../Molecules/PageHeaderBackground';

const PageHeaderCompShowcase = () => {

  return (
    <div>
      {/* PageHeaderSimple Component */}
      <PageSection>
        <ContentWrapper paddingBottom ='0'>
          <ContentWide>
            <h2>PageHeaderSimple - Page Headers</h2>
            <p>Page header component with 2 variants: default (min-height at desktop 1024px+) and minimal (grows with content at all breakpoints</p>
            <h4>Default Variant - With Back Link (min-height at desktop)</h4>
            </ContentWide>
        </ContentWrapper>
      </PageSection>
      
      <PageHeaderSimple
          variant="default"
          title="Page Title"
          description="Lorem ipsum dolor sit amet adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat."
          showBackButton={true}
          goBackText="Back to News"
      />
      <PageSection>
        <ContentWrapper paddingBottom ='0'>
          <ContentWide>
            <h4>Minimal Variant - Grows with Content</h4>
          </ContentWide>
        </ContentWrapper>
      </PageSection>
      
      <PageHeaderSimple
        variant="minimal"
        title="Minimal Page Title"
        description="Reduced spacing, theme background color, and smaller typography for a cleaner look."
        showBackButton={true}
        goBackText="Back to Home"
      />

      {/* PageHeaderBackground Component */}
      <PageSection>
        <ContentWrapper paddingBottom ='0'>
          <ContentWide>
            <h2>PageHeaderBackground - Page Headers</h2>
            <p className="components-showcase__description">This type of page header component supports displaying an image as a full-width background and follows a three-tier structure. 
              The bottom layer contains a full-width background image, while the middle layer features a full-width color container known as the overlay. 
              The top layer holds the content, which includes the same elements as the Page Simple component within the same structure. The content container is wrapped within a ContentWide component, and its horizontal alignment can be configured through a parameter.</p>          
              <h4>Default variant - With content container alignment set to default value (left) </h4>
           </ContentWide>
        </ContentWrapper>
      </PageSection>
      <PageHeaderBackground
        variant="default"
        title="About the CALIOPE modelling system"
        description="CALIOPE is the air quality forecasting system developed by the Earth Sciences Department at the Barcelona Supercomputing Center (BSC). Thanks to the potential in terms of data processing and analysis provided by supercomputing facilities, CALIOPE offers air quality forecasts research service for the Iberian Peninsula,Catalonia and the city of Barcelona."
        backgroundImage="https://caliope.bsc.es/our-model/@@images/hero_image"
      />

      <PageSection>
        <ContentWrapper paddingBottom ='0'>
          <ContentWide>
            <h4>Default variant - With content container alignment set to center but text aligned to left within the container</h4>
          </ContentWide>
        </ContentWrapper>
      </PageSection>

      <PageHeaderBackground
          variant="default"
          title="About the CALIOPE modelling system"
          description="CALIOPE is the air quality forecasting system developed by the Earth Sciences Department at the Barcelona Supercomputing Center (BSC). Thanks to the potential in terms of data processing and analysis provided by supercomputing facilities, CALIOPE offers air quality forecasts research service for the Iberian Peninsula,Catalonia and the city of Barcelona."
          backgroundImage="https://caliope.bsc.es/our-model/@@images/hero_image"
          alignment="center"
        />

      <PageSection>
        <ContentWrapper paddingBottom ='0'>
          <ContentWide>
            <h4>Default variant - With content container alignment set to center but text aligned to left within the container and without description</h4>
          </ContentWide>
        </ContentWrapper>
      </PageSection>
      <PageHeaderBackground
          variant="default"
          title="About the CALIOPE modelling system"
          backgroundImage="https://caliope.bsc.es/our-model/@@images/hero_image"
          alignment="center"
        />

      <PageSection>
        <ContentWrapper paddingBottom ='0'>
          <ContentWide>
            <h4>Default variant - With custom overlay color ("color-primary-02") and default overlay opacity (0.3)</h4>
          </ContentWide>
        </ContentWrapper>      
      </PageSection>
      <PageHeaderBackground
          variant="default"
          title="About the CALIOPE modelling system"
          description="CALIOPE is the air quality forecasting system developed by the Earth Sciences Department at the Barcelona Supercomputing Center (BSC). Thanks to the potential in terms of data processing and analysis provided by supercomputing facilities, CALIOPE offers air quality forecasts research service for the Iberian Peninsula,Catalonia and the city of Barcelona."
          backgroundImage="https://caliope.bsc.es/our-model/@@images/hero_image"
          overlayColor="var(--color-primary-02)"
      />

      <PageSection>
        <ContentWrapper paddingBottom ='0'>
          <ContentWide>
            <h4>Default variant - With custom overlay color ("color-primary-02") and custom overlay opacity (0.2)</h4>
          </ContentWide>
        </ContentWrapper>   
      </PageSection>
      <PageHeaderBackground
          variant="default"
          title="About the CALIOPE modelling system"
          description="CALIOPE is the air quality forecasting system developed by the Earth Sciences Department at the Barcelona Supercomputing Center (BSC). Thanks to the potential in terms of data processing and analysis provided by supercomputing facilities, CALIOPE offers air quality forecasts research service for the Iberian Peninsula,Catalonia and the city of Barcelona."
          backgroundImage="https://caliope.bsc.es/our-model/@@images/hero_image"
          overlayColor="var(--color-primary-02)"
          overlayOpacity="0.2"
      />
      
      <PageSection>
        <ContentWrapper paddingBottom ='0'>
          <ContentWide>
            <h4>Default variant - With default overlay (transparent) and custom text color ("color-primary-02")</h4>
          </ContentWide>
        </ContentWrapper>         
      </PageSection>

      <PageHeaderBackground
        variant="default"
        title="About the CALIOPE modelling system"
        description="CALIOPE is the air quality forecasting system developed by the Earth Sciences Department at the Barcelona Supercomputing Center (BSC). Thanks to the potential in terms of data processing and analysis provided by supercomputing facilities, CALIOPE offers air quality forecasts research service for the Iberian Peninsula,Catalonia and the city of Barcelona."
        backgroundImage="https://caliope.bsc.es/our-model/@@images/hero_image"
        textColor="var(--color-primary-02)"
      />

      <PageSection>
        <ContentWrapper paddingBottom ='0'>
          <ContentWide>
            <h4>Default variant - With custom height per each breakpoint: xs 220px, sm 250px, md 280px, lg 320px, xl 350px</h4>
          </ContentWide>
        </ContentWrapper>        
      </PageSection>

      <PageHeaderBackground
        variant="default"
        title="About the CALIOPE modelling system"
        backgroundImage="https://caliope.bsc.es/our-model/@@images/hero_image"
        height={{
          xs: '220px',
          sm: '250px',
          md: '280px',
          lg: '320px',
          xl: '350px'
        }}
      />
    </div>         
  );
};


export default PageHeaderCompShowcase;
